import script from "./WithdrawRewardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawRewardCard.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawRewardCard.vue?vue&type=style&index=0&id=41d53857&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d53857"]])

export default __exports__